import React from 'react';
import { FlexBox } from 'src/ui/common/atoms/flex-box';
import {
    Container,
    ImageInnerWrapper,
    InnerContainer,
    StyledAuthor,
    StyledTitle,
    StyledType,
    TextContainer,
    TextContainerWrapper,
} from './styles';

interface ImageWithTextProps {
    imageUrl?: string;
    author?: string;
    title?: string;
    type?: string;
}

export const ImageWithText: React.FC<ImageWithTextProps> = ({ imageUrl, author, title, type }) => (
    <Container hasImage={!!imageUrl}>
        <InnerContainer>
            {imageUrl && (
                <ImageInnerWrapper>
                    <img src={imageUrl} alt="" />
                </ImageInnerWrapper>
            )}
            <TextContainer>
                <TextContainerWrapper alignItems="flex-start">
                    <FlexBox gap="10" alignItems="center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                            <circle cx="4" cy="4.5" r="4" fill="white" />
                        </svg>
                        <StyledType variant="title" uppercase>
                            {type}
                        </StyledType>
                    </FlexBox>
                    <FlexBox flexDirection="column" gap="16">
                        <StyledTitle variant="title">{title}</StyledTitle>
                        <StyledAuthor variant="title" size="sm">
                            {author}
                        </StyledAuthor>
                    </FlexBox>
                </TextContainerWrapper>
            </TextContainer>
        </InnerContainer>
    </Container>
);